<template>
  <div class="table-responsive">
    <table class="table table-row-bordered gy-5">
      <thead>
      <tr class="fw-bold fs-6 text-muted">
        <th>Contato</th>
        <th>Canal</th>
        <th>Tipo de Acesso</th>
        <th>Status convite</th>
        <th>Status envio</th>
        <th>Ações</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="invite in invitesFiltered" :key="invite.id_invite">
        <td>{{ formatContact(invite) }}</td>
        <td>{{ invite.invite_channel_name }}</td>
        <td>{{invite.access_type.access_type_name}}</td>
        <td>
          <span class="badge badge-info" v-if="invite.invite_status === 'S'">Enviado</span>
          <span class="badge badge-danger" v-if="invite.invite_status === 'C'">Cancelado</span>
          <span class="badge badge-success" v-if="invite.invite_status === 'A'">Aceito</span>
          <span class="badge badge-warning" v-if="invite.invite_status === 'R'">Recusado</span>
        </td>
        <td>
          <span class="badge badge-light-info">{{ invite.latest_message?.latest_status_label || 'Enviado' }}</span>
        </td>
        <td>
          <div class="btn-group" v-if="invite.invite_status === 'S' || invite.latest_message">
            <button class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                    @click="$refs.messageModal.open(invite.id_invite)"
                    data-bs-toggle="tooltip" title="Histórico de envio">
              <i class="bi bi-clock-history"></i>
            </button>
            <button v-if="invite.invite_status === 'S'" class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                    @click="copyInviteLink(invite.invite_url)"
                    data-bs-toggle="tooltip" title="Copiar link do convite">
              <i class="bi bi-clipboard"></i>
            </button>
            <button v-if="invite.invite_status === 'S'" class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                    @click="resendInvite(invite.id_invite)"
                    data-bs-toggle="tooltip" title="Reenviar convite">
              <i class="bi bi-send-fill"></i>
            </button>
            <button v-if="invite.invite_status === 'S'" class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                    @click="cancelInvite(invite.id_invite)"
                    data-bs-toggle="tooltip" title="Cancelar convite">
              <i class="bi bi-x-octagon"></i>
            </button>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <div class="modal fade" tabindex="-1" id="modal_store">
    <div class="modal-dialog modal-lg">
      <form method="post" @submit.prevent="submitFormStore">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ createdInvites.length ? 'Link do convite' : 'Adicionar usuário' }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Fechar">
              <i class="bi bi-x-lg"></i>
            </div>
          </div>
          <div class="modal-body" v-if="createdInvites.length">
            <InviteLinkList :invites="createdInvites" />
          </div>
          <div class="modal-body" v-else>
            <div class="row">
              <div class="col-md-12">
                <div class="mb-6">
                  <div class="mt-4">
                    <label for="id_access_type_store" class="required form-label">Tipo de Acesso</label>
                    <select class="form-control form-control-solid" id="id_access_type_store"
                            aria-label="Selecione o convite" v-model="formStore.id_access_type" required>
                      <option value="">--Selecione--</option>
                      <option :value="accessType.id_access_type" v-for="accessType in accessTypes" :key="accessType.id_access_type">
                        {{ accessType.access_type_name }}
                      </option>
                    </select>
                    <small class="text-danger" v-if="formStoreErrors.id_access_type">
                      {{ formStoreErrors.id_access_type.join('\n') }}
                    </small>
                  </div>
                </div>
              </div>

              <div class="col-md-12 mb-6">
                <label class="required form-label">Canal de envio</label>
                <div class="d-flex gap-5">
                  <label class="form-check form-check-custom form-check-solid">
                    <input class="form-check-input" type="radio" value="email" v-model="formStore.invite_channel">
                    <span class="form-check-label">E-mail</span>
                  </label>
                  <label class="form-check form-check-custom form-check-solid">
                    <input class="form-check-input" type="radio" value="whatsapp" v-model="formStore.invite_channel">
                    <span class="form-check-label">WhatsApp</span>
                  </label>
                </div>
              </div>

              <div class="col-md-12" v-if="formStore.invite_channel === 'email'">
                <div class="form-group col-md-6">
                  <label for="add_user_email">E-mail(s) <span class="text-danger">*</span></label>
                  <div class="input-group mb-3">
                    <input type="email" class="form-control" id="add_user_email" v-model="email" maxlength="100">
                    <div class="input-group-append">
                      <button class="btn btn-md btn-primary ms-2" type="button" title="Adicionar e-mail" @click="addEmail">
                        <i class="bi bi-plus"></i>
                      </button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12" v-for="(item, index) in formStore.emails" :key="item">
                      <div class="alert alert-primary alert-dismissible fade show" style="width: fit-content">
                        {{ item }}
                        <button type="button" class="btn-close" @click="removeEmail(index)" aria-label="Close"></button>
                      </div>
                    </div>
                  </div>
                </div>
                <small class="text-danger" v-if="formStoreErrors.emails">{{ formStoreErrors.emails.join('\n') }}</small>
              </div>

              <div class="col-md-12" v-else>
                <div class="form-group col-md-6">
                  <label for="add_user_phone">Telefone <span class="text-danger">*</span></label>
                  <InvitePhoneField input-id="add_user_phone" v-model="formStore.phone" />
                </div>
                <small class="text-danger" v-if="formStoreErrors.phone">{{ formStoreErrors.phone?.join('\n') }}</small>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal">Fechar</button>
            <button v-if="!createdInvites.length" type="submit" class="btn btn-primary">Adicionar</button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <PlaceUserInviteMessageModal ref="messageModal" :place-id="place.id_place" />
</template>

<script>
import http from "../../helpers/http";
import Alert from "../../helpers/alert";
import PlaceUserInviteMessageModal from "../../components/invite/PlaceUserInviteMessageModal.vue";
import InvitePhoneField from "../../components/invite/InvitePhoneField.vue";
import InviteLinkList from "../../components/invite/InviteLinkList.vue";
import { copyInviteLink } from "../../components/invite/copyInviteLink";
import strMask from "../../helpers/strMask";

export default {
  name: "InviteUser",
  components: {
    PlaceUserInviteMessageModal,
    InvitePhoneField,
    InviteLinkList,
  },
  emits: ['onSubmit'],
  props: {
    searchParam: String,
  },
  data() {
    return {
      invites: [],
      accessTypes: [],
      email: '',
      formStore: {
        emails: [],
        phone: '',
        invite_channel: 'email',
        id_access_type: '',
      },
      formStoreErrors: [],
      createdInvites: [],
    }
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
    invitesFiltered() {
      if (!this.searchParam) {
        return this.invites;
      }

      return this.invites.filter(invite => {
        return (this.formatContact(invite) || '').toLowerCase().includes(this.searchParam.toLowerCase());
      });
    },
  },
  mounted() {
    this.loadAccessTypes();
    this.loadInvites();
    document.getElementById('modal_store')?.addEventListener('show.bs.modal', this.clearCreatedInvites);
  },
  beforeUnmount() {
    document.getElementById('modal_store')?.removeEventListener('show.bs.modal', this.clearCreatedInvites);
  },
  methods: {
    maskIt(value, mask) {
      return strMask.it(value, mask);
    },
    formatContact(invite) {
      if (invite.invite_channel === 'whatsapp') {
        return this.maskIt(invite.invite_phone, '(##) #####-####');
      }

      return invite.invite_email;
    },
    removeEmail(index) {
      this.formStore.emails.splice(index, 1);
    },
    addEmail() {
      if (!this.email) {
        return;
      }

      this.email.split(',').forEach((item) => {
        const trimmed = item.trim();
        if (trimmed && this.formStore.emails.indexOf(trimmed) === -1) {
          this.formStore.emails.push(trimmed);
        }
      });

      this.email = '';
    },
    buildInvitePayload() {
      const payload = {
        id_access_type: this.formStore.id_access_type,
        invite_channel: this.formStore.invite_channel,
      };

      if (this.formStore.invite_channel === 'email') {
        payload.emails = this.formStore.emails;
      } else {
        payload.phone = (this.formStore.phone || '').replace(/\D/g, '');
      }

      return payload;
    },
    copyInviteLink,
    clearCreatedInvites() {
      this.createdInvites = [];
    },
    submitFormStore() {
      http.post(`/places/${this.place.id_place}/users/invites`, this.buildInvitePayload()).then((response) => {
        this.$emit('onSubmit');
        this.loadInvites();
        Alert.toastSuccess("Convite enviado com sucesso.");
        this.formStoreErrors = [];
        this.formStore = {
          emails: [],
          phone: '',
          invite_channel: 'email',
          id_access_type: '',
        };
        this.email = '';
        this.createdInvites = response.data || [];
      }).catch((e) => {
        Alert.toastError(e.response.data.message ?? e.response.data);
        if (e.response.data.errors) {
          this.formStoreErrors = e.response.data.errors;
        }
      });
    },
    loadAccessTypes() {
      let params = {params: {'access_type_level': 'EM'}};
      http.get(`/places/${this.place.id_place}/access-types/for-invite`, params).then((response) => {
        this.accessTypes = response.data;
      });
    },
    loadInvites() {
      let params = {params: {'access_type_level': 'EM'}};
      http.get(`/places/${this.place.id_place}/users/invites`, params).then((response) => {
        this.invites = response.data;
      });
    },
    cancelInvite(inviteId) {
      Swal.fire({
        title: 'Heeyy',
        text: "Tem certeza que deseja cancelar o convite?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, cancelar!',
        cancelButtonText: 'Fechar',
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: 'btn btn-secundary'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          http.patch(`/places/${this.place.id_place}/users/invites/${inviteId}/cancel`).then(_ => {
            this.loadInvites();
            Alert.toastSuccess("Convite cancelado com sucesso.");
          }).catch(e => {
            Alert.toastError(e.response.data.message??e.response.data);
          })
        }
      });
    },
    resendInvite(inviteId) {
      http.post(`/places/${this.place.id_place}/users/invites/${inviteId}/resend`).then(_ => {
        this.loadInvites();
        Alert.toastSuccess("Convite reenviado com sucesso.");
      }).catch(e => {
        Alert.toastError(e.response.data.message ?? e.response.data);
      });
    }
  }
}
</script>

<style scoped>

</style>
